import { createFileRoute } from '@tanstack/react-router';

import type { BalanceSheetId } from '@/../convex/types';
import { BalanceSheetSettings } from '@/components/BalanceSheetSettings';
import { AuthenticatedRoute } from '@/lib/authenticatedRoute';

function SettingsPage() {
  const { id } = Route.useParams() as { id: BalanceSheetId };
  return (
    <div className="p-4">
      <BalanceSheetSettings id={id} />
    </div>
  );
}

export const Route = createFileRoute('/balance-sheet/$id/settings')({
  component: AuthenticatedRoute(SettingsPage),
});
